"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.find");

require("core-js/modules/es7.string.pad-start");

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.object.values");

require("core-js/modules/web.dom.iterable");

var _stockUp = require("@/api/cms/stock-up");

var _send = require("@/api/cms/send");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'PendingDelivery',
  data: function data() {
    return {
      tableLoading: false,
      exportLoading: false,
      stockUpLoading: false,
      confirmLoading: false,
      screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
      searchForm: {
        contractNo: '',
        custName: '',
        customerPhone: '',
        custAddress: '',
        productionOrder: '',
        dealer: '',
        scheduledDeliveryDate: '',
        stockInDate: ''
      },
      dataList: [],
      selectedRows: [],
      childSelectionMap: {},
      childSelecting: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      statistics: {
        total: 0,
        pendingSubmit: 0,
        pendingAudit: 0,
        pendingPrint: 0,
        pendingStock: 0,
        pendingSend: 0,
        shipped: 0
      },
      productionStatusMap: {
        10: '未提交',
        20: '待审图',
        30: '退回',
        40: '待确认图纸',
        45: '待工厂受理',
        50: '待拆单审核',
        51: '待移门拆单',
        55: '待拆单复审',
        60: '待报价审核',
        70: '待报价复审',
        80: '待经销商确认',
        90: '待付款确认',
        100: '待财务审核',
        105: '待物料采购',
        107: '待外协受理',
        110: '待生产计划',
        120: '计划已接单',
        130: '已排生产计划',
        150: '开始生产',
        160: '部分入库',
        170: '全部入库',
        180: '部分发货',
        190: '全部发货',
        200: '取消'
      },
      activeStatus: null,
      printDialogVisible: false,
      printDeliveryDate: '',
      confirmDialogVisible: false,
      confirmDeliveryDate: '',
      syncDialogVisible: false,
      syncLoading: false,
      syncForm: {
        date: '',
        orderNo: ''
      }
    };
  },
  computed: {
    tableHeight: function tableHeight() {
      return this.screenHeight * 0.6;
    },
    allSelectedChildIds: function allSelectedChildIds() {
      var ids = [];
      Object.values(this.childSelectionMap).forEach(function (arr) {
        if (Array.isArray(arr)) {
          arr.forEach(function (child) {
            return ids.push(child.id);
          });
        }
      });
      return ids;
    },
    selectedStockUpIds: function selectedStockUpIds() {
      var _this = this;

      var ids = [];
      Object.keys(this.childSelectionMap).forEach(function (auditId) {
        var children = _this.childSelectionMap[auditId];

        if (Array.isArray(children)) {
          children.forEach(function (child) {
            if (child.id) {
              ids.push(child.id);
            }
          });
        }
      });
      return ids;
    },
    statusTabs: function statusTabs() {
      return [{
        label: '全部',
        value: null,
        count: this.statistics.total
      }, {
        label: '待发起',
        value: 0,
        count: this.statistics.pendingSubmit
      }, {
        label: '待打单',
        value: 1,
        count: this.statistics.pendingPrint
      }, {
        label: '待备货',
        value: 2,
        count: this.statistics.pendingStock
      }, {
        label: '待出库',
        value: 3,
        count: this.statistics.pendingSend
      }, {
        label: '已出库',
        value: 4,
        count: this.statistics.shipped
      }];
    },
    columns: function columns() {
      return [{
        prop: 'dealerShopName',
        label: '经销商',
        minWidth: 120
      }, {
        prop: 'contractNo',
        label: '合同号',
        minWidth: 140
      }, {
        prop: 'orderNo',
        label: '订单号',
        minWidth: 140
      }, {
        prop: 'orderType',
        label: '订单类型',
        minWidth: 140
      }, {
        prop: 'custName',
        label: '客户姓名',
        minWidth: 100
      }, {
        prop: 'custMobile',
        label: '电话',
        minWidth: 120
      }, {
        prop: 'custAddress',
        label: '客户地址',
        minWidth: 160
      }, {
        prop: 'guideNickName',
        label: '销售员',
        minWidth: 100,
        type: 'jsonArray'
      }, {
        prop: 'designerNickName',
        label: '设计师',
        minWidth: 100,
        type: 'jsonArray'
      }, {
        prop: 'volume',
        label: '柜数',
        minWidth: 80
      }, {
        prop: 'signingTime',
        label: '签单日期',
        minWidth: 110,
        type: 'date'
      }, {
        prop: 'confirmPlanTime',
        label: '方案确认日期',
        minWidth: 120,
        type: 'date'
      }, {
        prop: 'agreedConstructionPeriod',
        label: '合同约定工期(天)',
        minWidth: 140
      }, {
        prop: 'agreedConstructionPeriod2',
        label: '合同约定工期',
        minWidth: 120,
        type: 'date'
      }, {
        prop: 'amount',
        label: '合同金额',
        minWidth: 110,
        align: 'right',
        type: 'money'
      }, {
        prop: 'amountReceived',
        label: '实收金额',
        minWidth: 110,
        align: 'right',
        type: 'money'
      }, {
        prop: 'paymentRatio',
        label: '收款比例',
        minWidth: 100
      }, {
        prop: 'productName',
        label: '产品名称',
        minWidth: 120
      }, {
        prop: 'color',
        label: '板材花色',
        minWidth: 140,
        align: 'left'
      }, {
        prop: 'stone',
        label: '石材材料',
        minWidth: 120
      }, {
        prop: 'stoneColor',
        label: '石材颜色',
        minWidth: 120,
        align: 'left'
      }, {
        prop: 'basinSource',
        label: '水盆来源',
        minWidth: 110
      }, {
        prop: 'basinQuantity',
        label: '水盆数量',
        minWidth: 100
      }, {
        prop: 'basinModel',
        label: '水盆型号',
        minWidth: 120
      }, {
        prop: 'faucetSource',
        label: '龙头来源',
        minWidth: 110
      }, {
        prop: 'faucetQuantity',
        label: '龙头数量',
        minWidth: 100
      }, {
        prop: 'faucetModel',
        label: '龙头型号',
        minWidth: 120
      }, {
        prop: 'specialProcessCycle',
        label: '特殊工艺生产周期',
        minWidth: 140
      }, {
        prop: 'specialProcessDelivery',
        label: '特殊工艺生产交期',
        minWidth: 140,
        type: 'date'
      }, {
        prop: 'specialProcessApply',
        label: '特殊工艺申请',
        minWidth: 130
      }, {
        prop: 'createUserName',
        label: '下单人',
        minWidth: 100
      }, {
        prop: 'orderClerkTime',
        label: '下单时间',
        minWidth: 110,
        type: 'date'
      }, {
        prop: 'auditorName',
        label: '审图人',
        minWidth: 100
      }, {
        prop: 'approveOrderTime',
        label: '审图时间',
        minWidth: 160
      }, {
        prop: 'dismantlePerson',
        label: '拆单人',
        minWidth: 100
      }, {
        prop: 'dismantleTime',
        label: '拆单时间',
        minWidth: 160
      }, {
        prop: 'quotePerson',
        label: '报价人',
        minWidth: 100
      }, {
        prop: 'approveQuoteTime',
        label: '报价时间',
        minWidth: 160
      }, {
        prop: 'payPerson',
        label: '经销商确认人',
        minWidth: 100
      }, {
        prop: 'approveFinanceTime',
        label: '经销商确认时间',
        minWidth: 160
      }, {
        prop: 'receivePerson',
        label: '财务审核人',
        minWidth: 100
      }, {
        prop: 'receiveTime',
        label: '财务审核时间',
        minWidth: 160
      }, {
        prop: 'planPerson',
        label: '排生产计划人',
        minWidth: 100
      }, {
        prop: 'palnProductionTime',
        label: '排生产计划时间',
        minWidth: 160
      }, {
        prop: 'shipmentDatePromise',
        label: '承诺交货日期',
        minWidth: 160
      }, {
        prop: 'productionStartDateTime',
        label: '开始生产日期',
        minWidth: 160
      }, {
        prop: 'completeSetDate',
        label: '齐套入库时间',
        minWidth: 160
      }, {
        prop: 'productionStatus',
        label: '订单状态',
        minWidth: 100
      }, {
        prop: 'actualOutTime',
        label: '出库时间',
        minWidth: 160
      }, {
        prop: 'totalArea',
        label: '总面积',
        minWidth: 100
      }, {
        prop: 'expandArea',
        label: '展开面积',
        minWidth: 100
      }, {
        prop: 'stoneLeng',
        label: '房门面积',
        minWidth: 100
      }, {
        prop: '',
        label: '台面米数',
        minWidth: 100
      }, {
        prop: 'totalPack',
        label: '总包数',
        minWidth: 100
      }, {
        prop: 'inPack',
        label: '入库包数',
        minWidth: 100
      }, {
        prop: 'warehouse',
        label: '仓库',
        minWidth: 100
      }, {
        prop: 'storage',
        label: '库位',
        minWidth: 100
      }];
    }
  },
  mounted: function mounted() {
    this.handleSearch();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
    },
    handleStatusTabClick: function handleStatusTabClick(status) {
      this.activeStatus = status;
      this.currentPage = 1;
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      var _this2 = this;

      this.tableLoading = true;
      this.loadStatistics();
      var params = {};
      if (this.searchForm.contractNo) params.contractNo = this.searchForm.contractNo;
      if (this.searchForm.custName) params.custName = this.searchForm.custName;
      if (this.searchForm.customerPhone) params.customerPhone = this.searchForm.customerPhone;
      if (this.searchForm.custAddress) params.custAddress = this.searchForm.custAddress;
      if (this.searchForm.productionOrder) params.productionOrder = this.searchForm.productionOrder;
      if (this.searchForm.dealer) params.dealer = this.searchForm.dealer;
      if (this.searchForm.scheduledDeliveryDate) params.scheduledDeliveryDate = this.searchForm.scheduledDeliveryDate;
      if (this.searchForm.stockInDate) params.stockInDate = this.searchForm.stockInDate;
      params.size = this.pageSize;
      params.page = this.currentPage - 1;

      if (this.activeStatus !== null) {
        params.status = this.activeStatus;
      }

      (0, _stockUp.getStockUpList)(params).then(function (response) {
        if (response.code === 200) {
          _this2.dataList = (response.data.content || []).map(function (row) {
            var parsed = {};

            if (row.materialData) {
              try {
                parsed = typeof row.materialData === 'string' ? JSON.parse(row.materialData) : row.materialData;
              } catch (_unused) {}
            }

            return _objectSpread(_objectSpread({
              _rowKey: row.auditId,
              auditId: row.auditId
            }, parsed), {}, {
              id: row.auditId,
              contractNo: row.contractNo,
              orderNo: row.productionOrder,
              orderType: parsed.orderType,
              custName: row.contactPerson,
              custMobile: row.contactNumber,
              custAddress: row.contactAddress,
              dealerShopName: row.dealerShopName,
              guideNickName: row.guideNickName,
              designerNickName: row.designerNickName,
              signingTime: row.signingTime,
              confirmPlanTime: row.confirmPlanTime,
              agreedConstructionPeriod: row.agreedConstructionPeriod,
              agreedConstructionPeriod2: row.scheduledDeliveryDate,
              amount: row.amount,
              amountReceived: row.amountReceived,
              paymentRatio: row.paymentRatio,
              productName: row.auditName || parsed.auditName,
              orderClerkTime: row.auditCreateTime,
              createUserName: row.createUserName,
              orderSolutions: row.orderSolutions || []
            });
          });
          _this2.total = response.data.totalElements || 0;
          _this2.childSelectionMap = {};
        } else {
          _this2.$message.error(response.msg || '查询失败');
        }
      }).catch(function () {
        _this2.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this2.tableLoading = false;
      });
    },
    loadStatistics: function loadStatistics() {
      var _this3 = this;

      (0, _stockUp.getStockUpStatistics)().then(function (response) {
        if (response.code === 200) {
          var s = response.data;
          _this3.statistics.pendingAudit = s.pendingAudit || 0;
          _this3.statistics.pendingPrint = s.pendingPrint || 0;
          _this3.statistics.pendingStock = s.pendingStock || 0;
          _this3.statistics.pendingSend = s.pendingSend || 0;
          _this3.statistics.shipped = s.shipped || 0;
          _this3.statistics.pendingSubmit = s.pendingSubmit || 0;
          _this3.statistics.total = s.total || 0;
        }
      });
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        contractNo: '',
        custName: '',
        customerPhone: '',
        custAddress: '',
        productionOrder: '',
        dealer: '',
        scheduledDeliveryDate: '',
        stockInDate: ''
      };
      this.currentPage = 1;
      this.handleSearch();
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    onRowClick: function onRowClick(row) {
      this.$refs.dataTable.toggleRowExpansion(row);
    },
    onParentSelect: function onParentSelect(selection, row) {
      if (this.childSelecting) return;
      var isSelected = selection.some(function (r) {
        return r.auditId === row.auditId;
      });
      var children = row.orderSolutions || [];
      var completedChildren = children.filter(function (c) {
        return c.isComplete === '是';
      });

      if (isSelected) {
        // 直接更新 childSelectionMap（只选已齐套的）
        this.childSelectionMap = _objectSpread(_objectSpread({}, this.childSelectionMap), {}, (0, _defineProperty2.default)({}, row.auditId, (0, _toConsumableArray2.default)(completedChildren))); // 如果子表格已渲染（行已展开），同步选中状态

        var childRef = this.$refs['childTable_' + row.auditId];

        if (childRef) {
          this.childSelecting = true;
          completedChildren.forEach(function (child) {
            return childRef.toggleRowSelection(child, true);
          });
          this.childSelecting = false;
        }
      } else {
        this.childSelectionMap = _objectSpread(_objectSpread({}, this.childSelectionMap), {}, (0, _defineProperty2.default)({}, row.auditId, []));
        var _childRef = this.$refs['childTable_' + row.auditId];

        if (_childRef) {
          this.childSelecting = true;

          _childRef.clearSelection();

          this.childSelecting = false;
        }
      }
    },
    onParentSelectAll: function onParentSelectAll(selection) {
      var _this4 = this;

      // 全选：将所有可见行的已齐套子方案加入 childSelectionMap
      this.childSelectionMap = {};
      selection.forEach(function (row) {
        var completedChildren = (row.orderSolutions || []).filter(function (c) {
          return c.isComplete === '是';
        });

        if (completedChildren.length > 0) {
          _this4.childSelectionMap[row.auditId] = (0, _toConsumableArray2.default)(completedChildren);
        }
      }); // 同步子表格选中状态（已展开的行）

      this.$nextTick(function () {
        _this4.dataList.forEach(function (row) {
          var childRef = _this4.$refs['childTable_' + row.auditId];

          if (childRef) {
            _this4.childSelecting = true;
            var isSelected = selection.some(function (r) {
              return r.auditId === row.auditId;
            });

            if (isSelected) {
              (row.orderSolutions || []).filter(function (c) {
                return c.isComplete === '是';
              }).forEach(function (child) {
                return childRef.toggleRowSelection(child, true);
              });
            } else {
              childRef.clearSelection();
            }

            _this4.childSelecting = false;
          }
        });
      });
    },
    onChildSelectChange: function onChildSelectChange(selection, parentRow) {
      if (this.childSelecting) return;
      this.childSelectionMap = _objectSpread(_objectSpread({}, this.childSelectionMap), {}, (0, _defineProperty2.default)({}, parentRow.auditId, selection));
      var children = parentRow.orderSolutions || [];
      var allSelected = children.length > 0 && children.every(function (c) {
        return selection.some(function (s) {
          return s.id === c.id;
        });
      });
      this.childSelecting = true;
      this.$refs.dataTable.toggleRowSelection(parentRow, allSelected);
      this.childSelecting = false;
    },
    handleView: function handleView(row) {
      this.$message.info('查看发货方案: ' + (row.contractNo || row.id));
    },
    handlePrint: function handlePrint() {
      var ids = this.selectedStockUpIds;

      if (ids.length === 0) {
        this.$message.warning('请先选择要打单的方案');
        return;
      } // 默认取第一个选中记录的 deliveryTime，否则用当天


      var deliveryTime = this.getSelectedDeliveryTime();

      if (deliveryTime) {
        var d = new Date(deliveryTime);
        this.printDeliveryDate = d.getFullYear() + '年' + String(d.getMonth() + 1).padStart(2, '0') + '月' + String(d.getDate()).padStart(2, '0') + '日 ' + String(d.getHours()).padStart(2, '0') + ':00';
      } else {
        var now = new Date();
        this.printDeliveryDate = now.getFullYear() + '年' + String(now.getMonth() + 1).padStart(2, '0') + '月' + String(now.getDate()).padStart(2, '0') + '日 ' + String(now.getHours()).padStart(2, '0') + ':00';
      }

      this.printDialogVisible = true;
    },
    getSelectedDeliveryTime: function getSelectedDeliveryTime() {
      var _this5 = this;

      var auditIds = Object.keys(this.childSelectionMap).filter(function (k) {
        return _this5.childSelectionMap[k] && _this5.childSelectionMap[k].length > 0;
      });
      if (auditIds.length === 0) return null;
      var firstParent = this.dataList.find(function (p) {
        return String(p.auditId) === auditIds[0];
      });
      return firstParent ? firstParent.deliveryTime : null;
    },
    handlePrintConfirm: function handlePrintConfirm() {
      var _this6 = this;

      var ids = this.selectedStockUpIds;

      if (!this.printDeliveryDate) {
        this.$message.warning('请选择发货时间');
        return;
      }

      this.exportLoading = true; // 转换为 yyyy-MM-dd HH:mm:ss 格式传给后端

      var deliveryTimeStr = this.printDeliveryDate.replace(/年|月/g, '-').replace(/日/, '').trim() + ':00';
      (0, _stockUp.printStockUp)(ids, deliveryTimeStr).then(function (response) {
        if (response.code === 200) {
          _this6.$message.success('打单成功');

          _this6.printDialogVisible = false;

          _this6.doExportSelection(_this6.printDeliveryDate).finally(function () {
            _this6.childSelectionMap = {};

            _this6.handleSearch();
          });
        } else {
          _this6.$message.error(response.msg || '打单失败');
        }
      }).catch(function () {
        _this6.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this6.exportLoading = false;
      });
    },
    handleStockUp: function handleStockUp() {
      var _this7 = this;

      var ids = this.selectedStockUpIds;

      if (ids.length === 0) {
        this.$message.warning('请先选择要备货的方案');
        return;
      }

      this.$confirm('您正在提交备货指令，订单将被推送到仓库备货，请确认无误后提交。', '确认备货', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this7.stockUpLoading = true;
        (0, _stockUp.stockUpStockUp)(ids).then(function (response) {
          if (response.code === 200) {
            _this7.$message.success('备货成功');

            _this7.childSelectionMap = {};

            _this7.handleSearch();
          } else {
            _this7.$message.error(response.msg || '备货失败');
          }
        }).catch(function () {
          _this7.$message.error('网络错误，请稍后重试');
        }).finally(function () {
          _this7.stockUpLoading = false;
        });
      }).catch(function () {});
    },
    onConfirmDeliveryChange: function onConfirmDeliveryChange(val) {
      if (!val) return; // 强制取整点到小时

      this.confirmDeliveryDate = val.replace(/\d{2}:\d{2}:\d{2}$/, function (m) {
        return m.split(':')[0] + ':00:00';
      });
    },
    onPrintDeliveryChange: function onPrintDeliveryChange(val) {
      if (!val) return; // 强制取整点到小时

      this.printDeliveryDate = val.replace(/\d{2}:\d{2}$/, function (m) {
        return m.split(':')[0] + ':00';
      });
    },
    handleConfirmSubmit: function handleConfirmSubmit() {
      var ids = this.selectedStockUpIds;

      if (ids.length === 0) {
        this.$message.warning('请先选择要确认发起的方案');
        return;
      }

      var now = new Date();
      this.confirmDeliveryDate = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0') + ' ' + String(now.getHours()).padStart(2, '0') + ':00:00';
      this.confirmDialogVisible = true;
    },
    handleConfirmSubmitConfirm: function handleConfirmSubmitConfirm() {
      var _this8 = this;

      var ids = this.selectedStockUpIds;

      if (!this.confirmDeliveryDate) {
        this.$message.warning('请选择发货时间');
        return;
      }

      this.confirmLoading = true;
      (0, _stockUp.confirmSubmitStockUp)(ids, this.confirmDeliveryDate).then(function (response) {
        if (response.code === 200) {
          _this8.$message.success('确认发起成功');

          _this8.confirmDialogVisible = false;
          _this8.childSelectionMap = {};

          _this8.handleSearch();
        } else {
          _this8.$message.error(response.msg || '确认发起失败');
        }
      }).catch(function () {
        _this8.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this8.confirmLoading = false;
      });
    },
    handleSyncOpen: function handleSyncOpen() {
      this.syncForm.date = '';
      this.syncForm.orderNo = '';
      this.syncDialogVisible = true;
    },
    handleSyncConfirm: function handleSyncConfirm() {
      var _this9 = this;

      var date = this.syncForm.date;
      var orderNo = this.syncForm.orderNo;

      if (!date && !orderNo) {
        this.$message.warning('请填写同步日期或订单号');
        return;
      }

      this.syncLoading = true;
      var params = {};
      if (date) params.date = date;
      if (orderNo) params.orderNo = orderNo;
      (0, _send.syncSolution)(params).then(function (response) {
        if (response.code === 200) {
          _this9.$message.success('方案同步成功');

          _this9.syncDialogVisible = false;

          _this9.handleSearch();
        } else {
          _this9.$message.error(response.msg || '方案同步失败');
        }
      }).catch(function () {
        _this9.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this9.syncLoading = false;
      });
    },
    doExportSelection: function doExportSelection(deliveryDate) {
      var _this10 = this;

      return new Promise(function (resolve) {
        var selectedGroups = [];
        Object.keys(_this10.childSelectionMap).forEach(function (auditId) {
          var children = _this10.childSelectionMap[auditId];

          if (Array.isArray(children) && children.length > 0) {
            var parent = _this10.dataList.find(function (p) {
              return String(p.auditId) === auditId;
            });

            if (parent) {
              selectedGroups.push({
                parent: parent,
                children: children
              });
            }
          }
        });

        if (selectedGroups.length === 0) {
          resolve();
          return;
        }

        var dateStr = deliveryDate || '';
        var html = "<!DOCTYPE html>\n<html>\n<head>\n  <meta charset=\"UTF-8\">\n  <title>\u6253\u5355\u5BFC\u51FA</title>\n  <style>\n    @page { size: A4; margin: 15mm; }\n    body { font-family: \"SimSun\", \"Microsoft YaHei\", serif; font-size: 13px; color: #000; }\n    table { border-collapse: collapse; width: 100%; margin-bottom: 20px; }\n    td, th { border: 1px solid #000; padding: 4px 8px; text-align: center; font-size: 13px; }\n    .header-row td { border: 1px solid #000; font-weight: bold; font-size: 15px; padding: 6px; }\n    .addr-row td { border: 1px solid #000; font-weight: bold; font-size: 13px; padding: 6px; }\n    .footer-row td { border: 1px solid #000; font-weight: bold; font-size: 13px; padding: 6px; }\n    .group-break { height: 20px; border: none; }\n    .group-break td { border: none; }\n    @media print {\n      .group-break { page-break-before: auto; }\n    }\n  </style>\n</head>\n<body>";
        var totalCount = selectedGroups.reduce(function (sum, g) {
          return sum + g.children.reduce(function (s, c) {
            return s + (c.packages || 0);
          }, 0);
        }, 0);
        html += '<table>';
        html += "<tr class=\"header-row\"><td colspan=\"5\">".concat(dateStr, "</td></tr>");
        html += "<tr class=\"addr-row\"><td colspan=\"5\">".concat(selectedGroups[0].parent.custAddress || '', "</td></tr>");
        html += "<tr><th>\u5408\u540C\u53F7</th><th>\u8BA2\u5355\u53F7</th><th>\u5165\u5E93\u9879</th><th>\u8D27\u4F4D</th><th>\u6570\u91CF</th></tr>";
        selectedGroups.forEach(function (group) {
          var parent = group.parent;
          var children = group.children;
          var contractNo = parent.contractNo || '';
          var orderNo = parent.orderNo || '';
          var childCount = children.length;
          children.forEach(function (child, idx) {
            html += '<tr>';

            if (idx === 0) {
              html += "<td rowspan=\"".concat(childCount, "\">").concat(contractNo, "</td>");
              html += "<td rowspan=\"".concat(childCount, "\">").concat(orderNo, "</td>");
            }

            html += "<td>".concat(child.solutionName || '', "</td>");
            html += "<td>".concat(child.location || '', "</td>");
            html += "<td>".concat(child.packages != null ? child.packages : '', "</td>");
            html += '</tr>';
          });
        });
        html += "<tr class=\"footer-row\"><td colspan=\"4\">\u53D1\u8D27\uFF1A \u5171 ".concat(totalCount, " \u4EF6</td><td>").concat(totalCount, "</td></tr>");
        html += '</table>';
        html += "\n</body>\n</html>";
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        iframe.contentDocument.write(html);
        iframe.contentDocument.close(); // write/close 后内容已就绪，直接触发打印

        setTimeout(function () {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
          resolve();
        }, 200);
      });
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.handleSearch();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.currentPage = current;
      this.handleSearch();
    },
    formatDate: function formatDate(date) {
      if (!date) return '';
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    formatDateTime: function formatDateTime(date) {
      if (!date) return '';
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hour = String(d.getHours()).padStart(2, '0');
      var min = String(d.getMinutes()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(min);
    },
    statusLabel: function statusLabel(status) {
      var map = {
        0: '待发起',
        1: '待打单',
        2: '待备货',
        3: '待出库',
        4: '已出库'
      };
      return map[status] != null ? map[status] : '-';
    },
    statusTagType: function statusTagType(status) {
      var map = {
        0: 'info',
        1: 'warning',
        2: 'warning',
        3: 'danger',
        4: 'success'
      };
      return map[status] || 'info';
    },
    parseJsonArray: function parseJsonArray(val) {
      if (!val) return '';

      try {
        var arr = JSON.parse(val);
        return Array.isArray(arr) ? arr.join('，') : val;
      } catch (_unused2) {
        return val;
      }
    },
    isChildSelectable: function isChildSelectable(row) {
      return row.isComplete === '是';
    },
    formatCellValue: function formatCellValue(row, col) {
      var val = row[col.prop];
      if (val == null || val === '') return '-';
      if (col.type === 'date') return this.formatDate(val);
      if (col.type === 'money') return '¥' + this.formatMoney(val);
      if (col.type === 'jsonArray') return this.parseJsonArray(val);
      if (col.prop === 'productionStatus') return this.productionStatusMap[val] || val;

      if (col.prop === 'color' || col.prop === 'stoneColor') {
        return String(val).replace(/^,+/g, '').replace(/,+$/g, '').replace(/,/g, '\n');
      }

      return val;
    },
    formatMoney: function formatMoney(val) {
      if (val == null) return '-';
      return Number(val).toFixed(2);
    }
  }
};
exports.default = _default;